const hiddenDealerSiteNavPrefixes = [
  '/dealer/profile',
  '/dealer/faq',
  '/dealer/home-page/merchandising-program',
  '/dealer/home-page/exterior-signage',
  '/dealer/home-page/showroom-project-request',
  '/dealer/cart',
  '/dealer/support-chats',
];

const hiddenDealerSiteNavExactPaths = ['/dealer', '/dealer/home-page'];

const isSectionLandingPath = pathname => /^\/dealer\/section\/[^/]+\/landing\/?$/i.test(pathname);

export const shouldShowDealerSiteNav = pathname => {
  if (!pathname) {
    return true;
  }

  if (isSectionLandingPath(pathname)) {
    return false;
  }

  if (hiddenDealerSiteNavExactPaths.includes(pathname)) {
    return false;
  }

  return !hiddenDealerSiteNavPrefixes.some(prefix => pathname.startsWith(prefix));
};
